import { translateFunc } from "client/utils/translateFunc";
import { Input } from "components/common/Input/Input";
import { ChangeEvent } from "react";
import { useTop } from "./useTop";

export interface TopProps {
    imageId: string;
    handleChange: (e: ChangeEvent<HTMLInputElement>) => void;
}

export const Top = ({ imageId, handleChange }: TopProps) => {
    const { top } = useTop(imageId);

    return (
        <div className="">
            <div className="capitalize mb-2">{translateFunc("position")} (Y)</div>
            <Input
                className="w-full"
                type="number"
                min={0}
                value={Math.round(top)}
                onChange={handleChange}
                data-testid="crop-settings-top"
            />
        </div>
    );
};
